import { formatDateTime } from '@core/utils/filter'

export default {
  namespaced: true,
  state: {

    selectedCampaign: null,

    selectedBrand: null,

    selectedDate: null,

    seoDate: null,

    seoEvent: null,

    seoEventList: null,

    selectedObjective: null,

    selectedSeoBrand: null,

    selectedSeoMonth: null,

    selectedDomain: null,

    selectedEvent: null,

    selectedEventWeb: null,

    selectedGrowthEvent: null,

    brandList: null,

    campaignList: null,

    objectiveList: null,

    domainList: null,

    seoBrandList: null,

    seoMonthList: null,

    eventList: null,

    eventWebList: null,

    growthEventList: null,

    isCampaignSelectionProper: false,

    isReady: false,

    isReadyMetrics: false,

    mediaFormData: null,

    taxForm: null,

    isEdit: false,

    addTax: false,

    defaultValues: {
      allCampaign: {
        title: 'All Campaigns',
        value: undefined,
        startDate: formatDateTime(new Date('2023-01-01')), // same with defaultVaules.date.startDate
        endDate: formatDateTime(new Date()), // same with defaultVaules.date.endDate
      },
      selectCampaign: {
        title: 'Select a Campaign',
        value: undefined,
        startDate: formatDateTime(new Date('2023-01-01')), // same with defaultVaules.date.startDate
        endDate: formatDateTime(new Date()), // same with defaultVaules.date.endDate
      },
      brand: {
        title: 'All Brands',
        value: 'B000001',
      },
      date: {
        startDate: formatDateTime(new Date('2023-01-01')), // same with defaultVaules.date.startDate
        endDate: formatDateTime(new Date()), // same with defaultVaules.date.endDate
      },
    },
  },
  getters: {
    getSelectedBrand: state => state.selectedBrand,
    getSelectedCampaign: state => state.selectedCampaign,
    getSelectedDomain: state => state.selectedDomain,
    getSelectedSeoBrand: state => state.selectedSeoBrand,
    getSelectedSeoMonth: state => state.selectedSeoMonth,
    getSelectedDate: state => state.selectedDate,
    getSelectedObjective: state => state.selectedObjective,
    getSelectedEvent: state => state.selectedEvent,
    getSelectedEventWeb: state => state.selectedEventWeb,
    getSelectedGrowthEvent: state => state.selectedGrowthEvent,
    getBrandList: state => state.brandList,
    getCampaignList: state => state.campaignList,
    getObjectiveList: state => state.objectiveList,
    getDomainList: state => state.domainList,
    getSeoBrandList: state => state.seoBrandList,
    getSeoMonthList: state => state.seoMonthList,
    getEventList: state => state.eventList,
    getEventWebList: state => state.eventWebList,
    getGrowthEventList: state => state.growthEventList,
    getIsCampaignSelectionProper: state => state.isCampaignSelectionProper,
    getIsReady: state => state.isReady,
    getIsReadyMetrics: state => state.isReadyMetrics,
    getDefaultAllCampaign: state => state.defaultValues.allCampaign,
    getDefaultSelectCampaign: state => state.defaultValues.selectCampaign,
    getDefaultBrand: state => state.defaultValues.brand,
    getDefaultDate: state => state.defaultValues.date,
    getMediaFormData: state => state.mediaFormData,
    getTaxForm : state => state.taxForm,
    getIsEdit: state => state.isEdit,
    getAddTax: state=> state.addTax,
    getSeoDate : state => state.seoDate,
    getSeoEvent: state => state.seoEvent,
    getSeoEventList: state => state.seoEventList
  },
  mutations: {
    setSelectedBrand(state, val) {
      state.selectedBrand = val
    },
    setSelectedCampaign(state, val) {
      state.selectedCampaign = val
    },
    setSelectedObjective(state, val) {
      state.selectedObjective = val
    },
    setSelectedDomain(state, val) {
      state.selectedDomain = val
    },
    setSelectedSeoBrand(state, val) {
      state.selectedSeoBrand = val
    },
    setSelectedSeoMonth (state, val) {
      state.selectedSeoMonth = val
    },
    setSelectedEvent(state, val) {
      state.selectedEvent = val
    },
    setMediaFormData(state, val) {
        state.mediaFormData = val
    },
    setTaxForm(state, val) {
        state.taxForm = val
    },
    setIsEdit(state, val) {
      state.isEdit = val
    },
    setAddTax(state, val) {
      state.addTax = val
    },
    setSelectedEventWeb(state, val) {
        state.selectedEventWeb = val
    },
    setSelectedGrowthEvent(state, val) {
        state.selectedGrowthEvent = val
    },
    setSelectedDate(state, val) {
      state.selectedDate = val
    },
    setBrandList(state, val) {
      state.brandList = val
    },
    setSeoMonthList(state, val) {
      state.seoMonthList = val
    },
    setCampaignList(state, val) {
      state.campaignList = val
    },
    setObjectiveList(state, val) {
      state.objectiveList = val
    },
    setDomainList(state, val) {
      state.domainList = val
    },
    setSeoBrandList(state,val) {
      state.seoBrandList = val
    },
    setEventList(state,val) {
        state.eventList = val
    },
    setEventWebList(state,val) {
        state.eventWebList = val
    },
    setGrowthEventList(state,val) {
        state.growthEventList = val
    },
    setIsCampaignSelectionProper(state, val) {
      state.isCampaignSelectionProper = val
    },
    setIsReady(state, val) {
      state.isReady = val
    },
    setIsReadyMetrics(state, val) {
      state.isReadyMetrics = val
    },
    setSeoDate(state, val) {
      state.seoDate = val
    },
    setSeoEvent (state,val) {
      state.seoEvent = val
    },
    setSeoEventList(state,val) {
      state.seoEventList = val
    }
  },
}
